// Modules
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Navigate } from 'react-router-dom';

// Components
import Layout from './Layout';
import Spinner from './spinner/SpinnerView';

// UI Component: wrapper of the page
const ProtectedPage = (props) => {
    const { loggedIn, loginPending, logoutPending, loginFailed, refreshLoginAuth } = props;
    const [loginChecked, setLoginChecked] = useState(loggedIn || loginPending);

    useEffect(() => {
        const checkAuthentication = () => {
            if (!loggedIn && !loginPending && !loginFailed && !loginChecked && !logoutPending) {
                setLoginChecked(true);
                refreshLoginAuth();
            }
        };
        checkAuthentication();
    }, [loggedIn, loginChecked, loginFailed, loginPending, logoutPending, refreshLoginAuth]);

    if (loginPending || !loginChecked || logoutPending) {
        return <Spinner />;
    }

    if (!loggedIn) {
        return <Navigate to="/login" replace />;
    }
    return <Layout>{props.children}</Layout>;
};

const mapStateToProps = (state) => ({
    loggedIn: state.uiState.authenticationState.loggedIn,
    loginPending: state.uiState.authenticationState.loginPending,
    loginFailed: state.uiState.authenticationState.loginFailed,
    logoutPending: state.uiState.authenticationState.logoutPending,
});

const mapDispatchToProps = {
    refreshLoginAuth: () => ({ type: 'REFRESH_LOGIN_AUTH' }),
};

export default connect(mapStateToProps, mapDispatchToProps)(ProtectedPage);
